import { render, staticRenderFns } from "./LineupPlayer.vue?vue&type=template&id=21f2c230&lang=html&"
import script from "./LineupPlayer.vue?vue&type=script&lang=js&"
export * from "./LineupPlayer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports